import { AssignKnowledgeBaseListItem } from 'src/pages/ControlDeskPage/DataSourceSection/KnowledgeBases/AssignKnowledgeBasePopup/AssignKnowledgeBaseListItem';
import type { KnowledgeBase } from 'src/services/knowledgeBaseService';

export const AssignKnowledgeBaseList = ({
  knowledgeBases,
}: {
  knowledgeBases?: KnowledgeBase[];
}) => {
  if (!knowledgeBases?.length) {
    return null;
  }

  return (
    <div className={'flex flex-col w-full'}>
      <div className={'pb-4 px-4'}>
        <p className={'font-bold text-ebony text-sm leading-5 select-none'}>
          Current knowledge bases
        </p>
      </div>
      <div>
        <ul className={'list-none w-full p-0 m-0 flex flex-col gap-4 max-h-64 overflow-auto px-4'}>
          {knowledgeBases.map((kb) => {
            return <AssignKnowledgeBaseListItem key={kb.id} knowledgeBase={kb} />;
          })}
        </ul>
      </div>
    </div>
  );
};
